import request from "@/utils/request";

export function fetchProvinceList(data) {
  return request({ url: "index/province", method: "get", data });
}

export function fetchPosterInfo() {
  return request({ url: "index/CourseSharePoster", method: "get" });
}
